import React from 'react';
import { useHistory } from 'react-router-dom';
import {
  Dropdown, Typography, Menu, Button,
} from 'antd';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

// import configAccountRoutes from '@routes/configAccountRoutes';
import authProvider from '@utils/auth/createAuthProvider';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserCircle } from '@fortawesome/free-solid-svg-icons';
import useSocket from '@common/hooks/useSocket';
import styles from './OptionsDropdown.module.less';
import { useSelector } from 'react-redux';

const { Text } = Typography;
const { Item } = Menu;
const { logout } = authProvider;

function OptionsDropdown(props) {

  const { username } = props;
  const { socketDisconnect } = useSocket();
  const user = useSelector(({ user: u }) => u);
  const history = useHistory();
  const { t } = useTranslation();

  // const { path: pathAccountConfig } = useMemo(() => {
  //   return configAccountRoutes.find(() => 'CONFIG_ACCOUNT');
  // }, []);

  const menu = (
    <Menu className={styles.dropdown_menu}>
      {/* <Item className={styles.dropdown_menu_item}>
        <Link to={pathAccountConfig}>{t('header.dropdown.account_settings')}</Link>
      </Item> */}
      <div className={styles.userInfo}>
        <b>{`${user.first_name} ${user.last_name}`}</b>
        {user.email}
      </div>
      {/* <Item className={styles.dropdown_menu_item}>
      </Item> */}
      <Item className={styles.dropdown_menu_item}>
        <Button
          className={styles.dropdown_menu_button}
          onClick={() => {

            history.push('/perfil');

          }}
        >
          {t('views.users.breadcrumb.me')}
        </Button>
      </Item>
      <Item className={styles.dropdown_menu_item}>
        <Button
          className={styles.dropdown_menu_button}
          onClick={() => {

            socketDisconnect();
            logout();

          }}
        >
          {t('header.dropdown.close_sesion')}
        </Button>
      </Item>
    </Menu>
  );

  return (
    <Dropdown
      className={styles.dropdown}
      trigger="click"
      placement="bottomRight"
      overlay={menu}
      arrow
    >
      <div className={styles.dropdown_content}>
        <FontAwesomeIcon className={styles.dropdown_icon} icon={faUserCircle} />
        <Text className={styles.dropdown_text} copyable={false}>
          {username}
        </Text>
      </div>
    </Dropdown>
  );

}

OptionsDropdown.propTypes = {
  username: PropTypes.string,
};

OptionsDropdown.defaultProps = {
  username: 'Unknow',
};

export default OptionsDropdown;
